import { canOrgUseFeatureAccess, getOrg } from '../entities/user';

export const getOrgFprintFromStoreNode = () => getOrg().fprint;

export const isUnifiedPlatform = () =>
  canOrgUseFeatureAccess('TAGS_V2', getOrg());
